import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles/components/landing.module.scss";
import { useSelector } from "react-redux";
import en from "../assets/images/en.webp";
import ar from "../assets/images/ar.webp";
import fr from "../assets/images/fr.webp";
import { Globe } from "lucide-react";

const flagIcons = {
  ar: ar,
  fr: fr,
  en: en,
};

// Language switcher for forms pages
const LanguageSwitcher = ({ currentLang, setCurrentLang, flag, setFlag }) => {
  const { t, i18n } = useTranslation();
  // Get available languages from Redux
  const availableLanguages =
    useSelector((state) => state.tenant?.tenant.languages) || [];

  // Switch language function
  const switchLanguage = (newLang) => {
    i18n.changeLanguage(newLang); // use i18n method so language is switched in all the app
    setCurrentLang(newLang);
  };

  return (
    <div
      className={styles.on_off_toggle_fr_landing}
      id="on-off-toggle-fr-mobile"
    >
      <div className={styles.langContainer}>
        {/* Dynamically render buttons only for available languages */}
        {availableLanguages.map(
          (lang) =>
            lang !== currentLang &&
            flagIcons[lang] && (
              <button
                key={lang}
                className={styles.lang}
                onClick={() => switchLanguage(lang)}
              >
                <img
                  className={styles.langFlag}
                  src={flagIcons[lang]}
                  alt={t(lang)}
                  loading="lazy"
                />
              </button>
            )
        )}
      </div>
    </div>
  );
};

// Language switcher for landing page
const LanguageSwitcherLanding = ({ currentLang, setCurrentLang }) => {
  const { t, i18n } = useTranslation();

  // Get available languages from Redux
  const availableLanguages =
    useSelector((state) => state.tenant?.tenant.languages) || [];

  // Switch language function
  const switchLanguage = (newLang) => {
    i18n.changeLanguage(newLang); // use i18n method so language is switched in all the app
    setCurrentLang(newLang);
  };

  return (
    <div
      className={styles.on_off_toggle_fr_landing}
      id="on-off-toggle-fr-mobile"
    >
      <div className={styles.langContainer}>
        {/* Render buttons only for activated languages for current tenant/client */}
        {availableLanguages.map(
          (lang) =>
            lang !== currentLang &&
            flagIcons[lang] && (
              <button
                key={lang}
                className={styles.lang}
                onClick={() => switchLanguage(lang)}
              >
                <img
                  className={styles.langFlag}
                  src={flagIcons[lang]}
                  alt={t(lang)}
                  loading="lazy"
                />
              </button>
            )
        )}
      </div>
    </div>
  );
};

const languages = {
  en: { code: "En", label: "English", flag: "🇬🇧" , logo : en },
  fr: { code: "Fr", label: "Français", flag: "🇫🇷" , logo : fr },
  ar: { code: "Ar", label: "العربية", flag: "🇸🇦" , logo : ar },
};

const NewLanguageSwitcherLanding = ({ currentLang, setCurrentLang }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  const { t, i18n } = useTranslation();

  // Get available languages from Redux
  const availableLanguages = useSelector((state) => state.tenant?.tenant.languages) || [];

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const switchLanguage = (newLang) => {
    i18n.changeLanguage(newLang); // use i18n method so language is switched in all the app
    setCurrentLang(newLang);
  };

  return (
    <div className={styles.lang_selector} ref={menuRef}>
      <button className={styles.lang_button} onClick={() => setOpen(!open)}>
        {/* <Globe size={18} className={styles.globe_icon} />*/}
        <img
          className={styles.lang_flag}
          src={languages[currentLang].logo}
          alt={t(currentLang)}
          loading="lazy"
        />
        <span>{languages[currentLang].code}</span>
        <svg
          className={styles.arrow + " " + (open ? styles.open : "")}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className={styles.lang_dropdown}>
          {availableLanguages.map((lang) => (
            <button
              key={languages[lang].code}
              className={styles.lang_item}
              onClick={() => {
                switchLanguage(lang);
                setOpen(false);
              }}
            >
              {/*<span className={styles.flag}>{languages[lang].flag}</span>*/}
              <img
                className={styles.lang_flag}
                src={languages[lang].logo}
                alt={t(lang)}
                loading="lazy"
              />
              <span className={styles.label}>{languages[lang].label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export {
  LanguageSwitcher,
  LanguageSwitcherLanding,
  NewLanguageSwitcherLanding,
};
